"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAICPAId = void 0;
const formatAICPAId = (id) => {
    const stringifiedId = `${id}`;
    return stringifiedId.startsWith('00') && stringifiedId.length === 9
        ? stringifiedId.slice(2, stringifiedId.length)
        : stringifiedId;
};
exports.formatAICPAId = formatAICPAId;
//# sourceMappingURL=index.js.map